import { alpha, Box, Skeleton, Stack } from '@mui/material';
import React from 'react';

const TabContentSkeleton: React.FC = () => {
  return (
    <Stack spacing={2} sx={{ pt: 1 }}>
      {/* Simula 3 ContentCards */}
      {[1, 2, 3].map((index) => (
        <Box
          key={index}
          sx={{
            borderRadius: 2.5,
            overflow: 'hidden',
            boxShadow: 1,
            backgroundColor: 'background.paper',
          }}
        >
          {/* Header skeleton */}
          <Box
            sx={{
              background: (theme) =>
                `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.12)} 0%, ${alpha(theme.palette.primary.main, 0.05)} 50%, ${alpha(theme.palette.primary.main, 0.01)} 100%)`,
              borderRadius: 2.5,
              px: 1.5,
              py: 1.25,
            }}
          >
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Skeleton
                variant="circular"
                width={36}
                height={36}
                sx={{ flexShrink: 0 }}
              />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Skeleton variant="text" width="60%" height={20} />
                <Skeleton
                  variant="text"
                  width="40%"
                  height={16}
                  sx={{ mt: 0.5 }}
                />
              </Box>
            </Stack>
          </Box>
          {/* Content skeleton */}
          <Box sx={{ p: 2 }}>
            <Stack spacing={1}>
              <Skeleton variant="text" width="100%" height={20} />
              <Skeleton variant="text" width="80%" height={20} />
              <Skeleton variant="text" width="90%" height={20} />
            </Stack>
          </Box>
        </Box>
      ))}
    </Stack>
  );
};

export default TabContentSkeleton;
